import type { ArtikelauswahlClientImplementation } from "@/legacy/artikelauswahlClient";
import type { ArtikelauswahlApiResponse } from "@/lib/models/artikelauswahl";
import { WarenkorbTyp } from "@/lib/models/warenkorb";

const badgeCssClass = "badge";

const warenkorbTypSelectorMapping = {
	[WarenkorbTyp.Warenkorb]: "shopping",
	[WarenkorbTyp.Anfragekorb]: "inquiry",
};

export class ArtikelauswahlGanter implements ArtikelauswahlClientImplementation {
	SetArtikelauswahlArtikelnummer(artikelNr: string) {
		$("#artikelnr").val(artikelNr);
	}

	AktualisiereMengenAnzeige(warenkorbtyp: WarenkorbTyp, anzahlPositionen: number) {
		let warenkorbTypSelector = warenkorbTypSelectorMapping[warenkorbtyp];
		let $anzahl = $("[data-" + warenkorbTypSelector + "-cart-amount='1']");
		let $mitPositionenInhalt = $("[data-" + warenkorbTypSelector + "-cart-content='1']");
		let $ohnePositionenInhalt = $("[data-" + warenkorbTypSelector + "-cart-content-empty='1']");
		// Das $anzahl-Element ist mehrfach vorhanden. Hier interessiert aber nur das Parent vom ersten $anzahl-Element
		// Das Element wird direkt in ein JQuery-Element geparst um die Funktionen .hasClass() und .addClass() bereitzustellen
		let $headerCount = $($anzahl.parent()[0]!);
		$anzahl.html(anzahlPositionen.toString());

		if (anzahlPositionen > 0) {
			$mitPositionenInhalt.show();
			$ohnePositionenInhalt.hide();
			if (!$headerCount.hasClass(badgeCssClass)) {
				$headerCount.addClass(badgeCssClass);
			}
		} else {
			$mitPositionenInhalt.hide();
			$ohnePositionenInhalt.show();
			$headerCount.removeClass(badgeCssClass);
		}
	}

	SetArtikelauswahlNormblattBild(data: ArtikelauswahlApiResponse) {
		if (data.bildUrl == null) return;

		let $imageSlider = $("div.product-image__wrapper.slider-image");
		// Im ImageSlider gibt es ein img-Element. Dieses wird hier abgeholt
		let $childImage = $imageSlider.children("img");
		$childImage.attr("src", data.bildUrl);
		$childImage.attr("alt", data.bildAlt);

		let $imageCaption = $("div.product-image__caption");
		$imageCaption.html(data.bildCaption);
	}
}
